import { __rest } from "tslib";
import React from 'react';
import { Check, ChevronDown, ChevronUp } from '@gravity-ui/icons';
import { Icon } from '../../../Icon';
import { Text, colorText } from '../../../Text';
import { Flex, spacing } from '../../../layout';
import { block } from '../../../utils/cn';
import { LIST_ITEM_DATA_ATR, modToHeight } from '../../constants';
import './ListItemView.css';
const b = block('list-item-view');
export const ListItemViewSlot = (_a) => {
    var { children, indentation: indent = 1, className } = _a, props = __rest(_a, ["children", "indentation", "className"]);
    return (React.createElement(Flex, Object.assign({ className: b('slot', { indent }, className) }, props), children));
};
const renderSafeIndentation = (indentation) => {
    if (indentation && indentation >= 1 && indentation < 11) {
        return (React.createElement(ListItemViewSlot, { indentation: Math.floor(indentation) }));
    }
    return null;
};
export const ListItemView = React.forwardRef((_a, ref) => {
    var { id, as = 'div', size = 'm', active, selected, disabled, activeOnHover = true, className, hasSelectionIcon = true, indentation, startSlot, subtitle, endSlot, title, height, expanded, dragging, style, role = 'option', onClick: _onClick } = _a, rest = __rest(_a, ["id", "as", "size", "active", "selected", "disabled", "activeOnHover", "className", "hasSelectionIcon", "indentation", "startSlot", "subtitle", "endSlot", "title", "height", "expanded", "dragging", "style", "role", "onClick"]);
    const isGroup = typeof expanded === 'boolean';
    const onClick = disabled ? undefined : _onClick;
    return (React.createElement(Flex, Object.assign({ role: role, "aria-selected": selected, onClick: onClick, className: b({
            active: dragging || active,
            selected: selected && !hasSelectionIcon,
            activeOnHover,
            radius: size,
            dragging,
            clickable: Boolean(onClick),
        }, spacing({ px: 2 }, className)), style: Object.assign({ minHeight: height !== null && height !== void 0 ? height : modToHeight[size][Number(Boolean(subtitle))] }, style), as: as, ref: ref, [LIST_ITEM_DATA_ATR]: id ? id : undefined, alignItems: "center", gap: "4", justifyContent: "space-between" }, rest),
        React.createElement(Flex, { gap: "2", alignItems: "center" },
            hasSelectionIcon && (React.createElement(ListItemViewSlot // reserve space
            , null, selected ? (React.createElement(Icon, { data: Check, size: 16, className: colorText({ color: 'info' }) })) : null)),
            renderSafeIndentation(indentation),
            isGroup ? (React.createElement(Icon, { className: b('icon', colorText({ color: disabled ? 'hint' : undefined })), data: expanded ? ChevronDown : ChevronUp, size: 16 })) : null,
            startSlot,
            React.createElement("div", { className: b('main-content') },
                typeof title === 'string' ? (React.createElement(Text, { ellipsis: true, color: disabled ? 'hint' : undefined, variant: isGroup ? 'subheader-1' : undefined }, title)) : (title),
                typeof subtitle === 'string' ? (React.createElement(Text, { ellipsis: true, color: disabled ? 'hint' : 'secondary' }, subtitle)) : (subtitle))),
        endSlot));
});
ListItemView.displayName = 'ListItemView';
